import { Button, Select, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import classes from './FAQ.module.scss';
import React from 'react';
import { useAppDispatch } from 'store/hook';
import { clearReduxFunction } from 'store/reducers/userDataCreator';
import { getBuildDefaultLanguage } from 'helpers/getBuildDefaultLanguage';
import { languagesValues } from 'routes/Main/Main';
import FAQTab from './Tabs/FAQTab';
import { useNavigate } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';

export default function FAQ() {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'FAQ' });
  const savedLanguage = ['ru', 'en'].includes(localStorage.getItem('language') || '') && localStorage.getItem('language');
  const defaultLanguage = savedLanguage || getBuildDefaultLanguage();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onLanguageChange = (value: string) => {
    localStorage.setItem('language', value);
    i18n.changeLanguage(value);
  };

  React.useEffect(() => {
    dispatch(clearReduxFunction({}));
    i18n.changeLanguage(defaultLanguage);

    return () => {
      i18n.changeLanguage(String(localStorage.getItem('language') || ''));
    }
  }, []);

  const items = [
    {
      key: 'FAQ',
      label: t('FAQ.title'),
      children: (
        <div className={classes.container}>
          <FAQTab t={t} />
        </div>
      ),
    },
  ];

  return (
    <div className={classes.wrapper}>
      <div className={classes.mainSpace}>
        <Tabs
          items={items}
          className={classes.tabs}
          tabBarExtraContent={{
            left: (
              <Button
                // type='text'
                icon={<LeftOutlined />}
                className={classes.backBtn}
                onClick={() => navigate(-1)}
              >
                {t('FAQ.backBtn')}
              </Button>
            ),
            right: (
              <Select
                className={classes.localizationSelect}
                defaultValue={defaultLanguage}
                onChange={onLanguageChange}
                style={{ minWidth: 130 }}
                options={languagesValues.filter(lang => ['ru', 'en'].includes(lang.value))}
                optionLabelProp={'label'}
              />
            )
          }} 
        />
      </div>
    </div>
  );
}
